<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>留学资源回访查询</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="学校" label-width="80px" style="margin-left:-15px;">
          <el-select v-model="query.schid" filterable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in schoollist"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <SelectAbroad v-on:selabroad="function(str){query.abroadTime=str;selList();}"></SelectAbroad>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>学生回访列表</span>
        </div>
        <!-- <el-tabs v-model="state" @tab-click="stateClick">
          <el-tab-pane label=" 待处理 " name="2"></el-tab-pane>
          <el-tab-pane label=" 待提醒 " name="1"></el-tab-pane>
          <el-tab-pane label=" 已处理 " name="3"></el-tab-pane>
        </el-tabs> -->
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <!-- <el-table-column prop="subject" label="回访主题"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.state==3">{{scope.row.stateName}}</el-tag>
              <el-tag type="danger" v-if="scope.row.state==2">{{scope.row.stateName}}</el-tag>
              <el-tag type="info" v-if="scope.row.state==1">{{scope.row.stateName}}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="stuName" label="姓名"></el-table-column>
          <el-table-column prop="abroadDate" label="留学时间"></el-table-column>
          <el-table-column prop="applySchool" label="语言学校"></el-table-column>
          <el-table-column prop="school" label="升学院校"></el-table-column>
          <el-table-column prop="japanese" label="日语"></el-table-column>
          <el-table-column prop="english" label="英语"></el-table-column>
          <el-table-column prop="profession" label="专业"></el-table-column>
          <el-table-column prop="privateSchool" label="报私塾"></el-table-column>
          <el-table-column prop="incomeDate" label="入学时间"></el-table-column>
          <el-table-column prop="other" label="其他发展"></el-table-column>
          <el-table-column prop="summary" label="备注"></el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="基本信息" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="查看聊天截图" placement="top" v-if="scope.row.imgList">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-picture"
                    @click="imgClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id>0?'编辑学生回访':'添加学生回访'"
      :visible.sync="dialogVisible"
      @opened="dialogOpended();"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-divider content-position="left" style>{{form.subject}}</el-divider>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="升学院校" prop="school">
              <el-input v-model="form.school" placeholder="请输入升学院校"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入学时间" prop="incomeDate">
              <el-date-picker
                v-model="form.incomeDate"
                value-format="yyyy-MM"
                format="yyyy-MM"
                type="month"
                placeholder="选择入学时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="日语" prop="japanese">
              <el-select v-model="form.japanese" placeholder="请选择" filterable>
                <el-option
                  v-for="item in japlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="英语" prop="english">
              <el-select v-model="form.english" placeholder="请选择" filterable>
                <el-option
                  v-for="item in enlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="专业" prop="summary">
          <el-input v-model="form.profession" placeholder="请输入专业"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报私塾" prop="privateSchool">
              <el-select v-model="form.privateSchool" placeholder="请选择" filterable>
                <el-option
                  v-for="item in [{id:'是',name:'是'},{id:'否',name:'否'}]"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="其他发展" prop="other">
              <el-select v-model="form.other" placeholder="请选择" filterable>
                <el-option
                  v-for="item in otherlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注" prop="summary">
          <el-input v-model="form.summary" placeholder="请输入备注"></el-input>
        </el-form-item>

        <el-form-item label="聊天截图" prop="pictures">
          <div id="uploadBtn" class="uploader uploader-warning"></div>

          <el-row :gutter="20">
            <el-col :span="5" v-for="(item,index) in imgList" :key="index">
              <el-card style="margin-top:10px;">
                <img :src="domain+item" class="image" style="max-height:100px;" />
                <div style="padding: 0px;">
                  <div class="bottom clearfix">
                    <el-button-group>
                      <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteImg(index)"
                      ></el-button>
                    </el-button-group>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
        <div style="height:10px;"></div>

        <el-divider content-position="left">{{form.nextSubject}}</el-divider>

        <template v-if="form.visitCount==1">
          <el-form-item label="回访时间" prop="day" :rules="[{required:false,message:'不能为空'}]">
            <el-col :span="5">
              <el-input v-model="form.nextNoticeDate" readonly></el-input>
            </el-col>
            <el-col :span="1" style="text-align:center;">-</el-col>
            <el-col :span="5">
              <el-select v-model="form.day" placeholder="请选择天" filterable style="width:100%;">
                <el-option v-for="item in dayList" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="回访人" prop="nextNoticeID" :rules="[{required:false,message:'不能为空'}]">
            <el-select v-model="form.nextNoticeID" placeholder="请选择" filterable>
              <el-option
                v-for="item in documentlist"
                :label="item.realName"
                :value="item.userID"
                :key="item.userID"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="回访时间" prop="day">
            <el-col :span="5">
              <el-input v-model="form.nextNoticeDate" readonly></el-input>
            </el-col>
            <el-col :span="1" style="text-align:center;">-</el-col>
            <el-col :span="5">
              <el-select v-model="form.day" placeholder="请选择天" filterable style="width:100%;">
                <el-option v-for="item in dayList" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="回访人" prop="NoticeUserName">
            <el-select v-model="form.nextNoticeID" placeholder="请选择" filterable>
              <el-option
                v-for="item in adviserlist"
                :label="item.realName"
                :value="item.userID"
                :key="item.userID"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 图片对话框 -->
    <el-dialog title="聊天截图列表" :visible.sync="imgDialogVisible">
      <el-row :gutter="20">
        <el-col :span="5" v-for="(item,index) in imgList" :key="index">
          <a :href="domain+item" target="_blank">
            <el-card style="margin-top:10px;text-align:center;">
              <img :src="domain+item" class="image" style="max-height:100px;" />
              <div style="padding: 8px 0px 0px 0px;">
                <div class="bottom clearfix">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    style="margin-left:0px;"
                  ></el-button>
                </div>
              </div>
            </el-card>
          </a>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 查看基本信息 -->
    <el-dialog title="基本信息" :visible.sync="viewDialog">
      <table
        class="myTable el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="width:100%;line-height:2em;"
      >
         <tr>
              <td>姓名：{{info.realName}}</td>
              <td>性别：{{info.sex?'男':'女'}}</td>
            </tr>
            <tr>
              <td>留学时间：{{info.abroadDate}}</td>
              <td>来源：{{info.origin}} {{info.recName}}</td>
            </tr>
            <tr>
              <td>微信：{{info.wechat}}</td>
              <td>QQ：{{info.qq}}</td>
            </tr>
            <tr>
              <td>电话：{{info.mobile}}</td>
              <td>地区：{{info.zzProvinceName+info.zzCityName}}</td>
            </tr>
            <tr>
              <td>学历：{{info.eduBack}}</td>
              <td></td>
            </tr>
            <tr>
              <td>日语：{{info.japanese}}</td>
              <td>英语：{{info.english}}</td>
            </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="viewDialog = false;">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import dateHelper from "@/plugins/dateHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    return {
      domain: url.getDomain(),
      key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      imgDialogVisible: false,
      state: "3",
      submiting: false,
      stuid: 0,
      japlist: url.getJapLevelListForStu(), // 日语水平（统一数据）
      enlist: [
        { id: "好", name: "好" },
        { id: "一般", name: "一般" },
        { id: "差", name: "差" },
        { id: "有托福托业成绩", name: "有托福托业成绩" },
      ], //英语水平
      otherlist: [
        { id: "就职", name: "就职" },
        { id: "回国", name: "回国" },
        { id: "专门学校", name: "专门学校" },
        { id: "其他", name: "其他" },
      ], //其他发展
      imgList: [], //上传图片列表
      dayList: [],
      adviserlist: [], //获取回访人  顾问老师
      documentlist: [], //获取回访人  文案老师
      schoollist: [], //获取学校
      abroadTimeDialog2: false,
      viewDialog: false,
      info: {}, //基本信息对象
    };
  },
  components: {
    SelectAbroad,
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      params.state = _this.state;
      params.isPublic=true;
      var link = url.getStu("getlist_visit");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //按状态查询
    stateClick: function (tab, event) {
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 获取回访人-顾问老师：不再按板块，用所有启用用户
    noticeadviserlist: function () {
      var _this = this;
      $.get(url.getStu("getenableusers"), {}, (data) => {
        _this.adviserlist = data || [];
      });
    },
    //获取回访人  文案老师
    noticedocumentlist: function () {
      var _this = this;
      var link = url.getStu("getdocument");
      $.get(link, {}, (data) => {
        _this.documentlist = data;
      });
    },
    //获取学校
    school: function () {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, (data) => {
        _this.schoollist = data;
      });
    },
    //查看基本信息
    viewClick(row) {
      var _this = this;
      var id = row.stuID;
      this.viewDialog = true;
      var link = url.getStu("getvisit_stu");
      $.get(link, { stuid: id }, (data) => {
        _this.info = data;
      });

    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStu("addorupdate_visit");
      var info = Object.assign({}, this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          info.nextNoticeDate =
            _this.form.nextNoticeDate + "-" + _this.form.day;
          info.imgList = _this.imgList.toString();

          this.submiting = true;
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //查看图片
    imgClick(row) {
      var _this = this;
      if (row.imgList) {
        _this.imgList = row.imgList.split(",");
        _this.imgDialogVisible = true;
      }
    },
    //编辑
    editClick: function (row) {
      var _this = this;
      this.dialogVisible = true;
      var id = row.id;
      var link = url.getStu("getvisit");
      $.get(link, { id: id }, (data) => {
        _this.form = data;
        _this.imgList = [];
        if (data.imgList) {
          _this.imgList = data.imgList.split(",");
        }
        //加载天
        _this.initDayList();
      });
    },
    initDayList: function () {
      var _this = this;
      var list = dateHelper.getDayList(this.form.nextNoticeDate);
      this.dayList = list;
      this.form.day = 1;
    },
    //跳转详情
    goTo: function (id) {
      this.$router.push({
        name: "follow",
        query: { id: id },
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getStu("delete_base"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    dialogOpended() {
      var _this = this;
      /**截图上传**/
      if ($("#uploadBtn .uploader_text").length <= 0)
        $("#uploadBtn").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          type: "single", //指定处理类型
          max: 1024 * 1024 * 1,
          maxWidth: 2000,
          maxHeight: 2000,
          onSuccess: function (data) {
            //添加到列表,每个图片上传成功都会触发
            _this.imgList.push(data.relativeName);
          },
        });
    },
  },
  created() {},
  mounted() {
    var _this = this;

    //获取服务器列表
    this.getList();
    //获取学校
    this.school();
    //获取回访人  顾问老师
    this.noticeadviserlist();
    //获取回访人  文案老师
    this.noticedocumentlist();
  },
};
</script>

<style  scoped>
.myTable td {
  text-indent: 10px;
}
</style>
